<template>
  <div
  v-bind:class="{'person':true, 'active':(active)}">
    <div class="icon"> <span
                    aria-hidden="true"
                    class="fa fa-user"
                    style="color: #4ae387; font-size: 25px;"
                  ></span>
    </div>
    <div class="name"> {{label}} </div>
  </div>
</template>

<script>

export default {
  name: "person",
  components: {
    
  },
  props: {
    label: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {

    return {
      locked: false,
      free: true
    };
  },
  mounted: function () {
    //nothing yet 
  },
  methods: {

    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.person {
  display: flex;
  flex-direction: row;
  width: 200px;
  justify-content: center;
  margin: 20px;
  
}
.icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  
}
.name {
  width: 100%;
  vertical-align: middle;
}
.active {
  // background-color: #4ae38750;
  color: #4ae387;
  font-weight: bold;
}
</style>
